import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["QueryDropdown"], {
        "filter-key": "sort",
        "filter-options": $setup.sortOptions,
        disabled: $setup.articlesStore.isLoading
    }, null, 8 /* PROPS */, ["disabled"]));
}
